import { Modal, ModalContent, ModalHeader, ModalBody } from '@nextui-org/react'
import { useTranslation } from 'react-i18next'

import { LittleText, Text } from '@/components/common/UI'
import { Accordion, AccordionItem } from '@/components/nextui'

interface ModalTypesEntryProps {
    isOpen: boolean
    text: string
    onOpenChange: (isOpen: boolean) => void
}

export const ModalTypesEntry = ({
    isOpen,
    text,
    onOpenChange
}: ModalTypesEntryProps) => {
    const { t } = useTranslation()
    const newText = `${text}.typesEntry`

    const defaultContent = [
        {
            title: t(`${newText}.title1`),
            content: t(`${newText}.content1`)
        },
        {
            title: t(`${newText}.title2`),
            content: t(`${newText}.content2`)
        },
        {
            title: t(`${newText}.title3`),
            content: t(`${newText}.content3`)
        },
        {
            title: t(`${newText}.title4`),
            content: t(`${newText}.content4`)
        },
        {
            title: t(`${newText}.title5`),
            content: t(`${newText}.content5`)
        }
    ]

    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            placement="center"
            scrollBehavior="inside"
        >
            <ModalContent>
                <ModalHeader>
                    <Text
                        text={t(`${text}.modalTypesEntryTitle`)}
                        className="text-primary font-bold"
                    />
                </ModalHeader>
                <ModalBody>
                    <Accordion>
                        {defaultContent.map((item, index) => (
                            <AccordionItem
                                key={index}
                                aria-label={item.title}
                                title={item.title}
                            >
                                <LittleText text={item.content} />
                            </AccordionItem>
                        ))}
                    </Accordion>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}
